module.exports = __webpack_public_path__ + "img/returns-the-background.f7f80da1.png";